import { useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetMessage, setResetMessage] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setResetMessage("");
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const userDoc = await getDoc(doc(db, "users", user.uid));

      if (!userDoc.exists()) {
        setError("Account data missing. Contact support.");
        setLoading(false);
        return;
      }

      const role = userDoc.data().role;

      if (role === "owner") navigate("/owner");
            else if (role === "charity") navigate("/charity");
      else if (role === "admin") navigate("/admin");

    else setError("Unrecognized account type. Contact support.");
    } catch (err) {
      setError("Incorrect email or password");
    }

    setLoading(false);
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setError("Enter your email above first, then click 'Forgot password'");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMessage("Password reset email sent — check your inbox.");
      setError("");
    } catch (err) {
      setError("Couldn't send reset email. Check that the address is correct.");
    }
  };

  return (
    <div style={styles.shell}>
      <div style={styles.card}>
        <h1 style={{ margin: "0 0 8px", textAlign: "center" }}>
          <img src="/logo-header.png" alt="Bar Fun Finder" style={{ width: "220px", maxWidth: "100%", height: "auto" }} />
        </h1>
        <h2 style={styles.heading}>Sign In</h2>

        <form onSubmit={handleLogin} style={styles.form}>
          <label style={styles.label}>Email</label>
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />

          <label style={styles.label}>Password</label>
          <input
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? "Signing in..." : "Sign In"}
          </button>

          {error && <p style={styles.error}>{error}</p>}
          {resetMessage && <p style={styles.success}>{resetMessage}</p>}
        </form>

        <button type="button" onClick={handleForgotPassword} style={styles.linkButton}>
          Forgot password?
        </button>

        <p style={styles.footerText}>
          Don't have an account? <Link to="/signup" style={styles.link}>Create one</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  shell: {
    minHeight: "100vh",
    background: "#050409",
    backgroundImage:
      "linear-gradient(90deg, rgba(30,27,75,0.45) 0%, rgba(10,8,16,0.2) 25%, rgba(192,38,163,0.18) 50%, rgba(10,8,16,0.2) 75%, rgba(30,27,75,0.45) 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    fontFamily: "Inter, sans-serif",
  },
  card: {
    background: "#0D0B1A",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "16px",
    padding: "40px",
    width: "100%",
    maxWidth: "380px",
    boxShadow: "0 0 60px rgba(139,92,246,0.08)",
  },
  logo: {
    fontSize: "28px",
    fontWeight: 700,
    textAlign: "center",
    margin: "0 0 8px",
    background: "linear-gradient(90deg, #FF3D81, #8B5CF6)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  heading: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#fff",
    textAlign: "center",
    margin: "0 0 28px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  label: {
    fontSize: "16px",
    color: "#B8B0C8",
    marginBottom: "2px",
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid rgba(255,255,255,0.1)",
    background: "#16121F",
    color: "#fff",
    fontSize: "15px",
    marginBottom: "14px",
    boxSizing: "border-box",
  },
  button: {
    background: "linear-gradient(90deg, #6D28D9, #A855F7)",
    border: "none",
    padding: "13px",
    borderRadius: "8px",
    color: "#fff",
    fontWeight: 600,
    fontSize: "15px",
    cursor: "pointer",
    marginTop: "6px",
  },
  linkButton: {
    background: "none",
    border: "none",
    color: "#A855F7",
    cursor: "pointer",
    padding: 0,
    fontSize: "16px",
    marginTop: "16px",
    display: "block",
  },
  footerText: {
    color: "#B8B0C8",
    fontSize: "16px",
    marginTop: "20px",
    textAlign: "center",
  },
  link: {
    color: "#FF3D81",
    fontWeight: 600,
  },
  error: {
    color: "#F472B6",
    fontSize: "16px",
    marginTop: "10px",
  },
  success: {
    color: "#4ADE80",
    fontSize: "16px",
    marginTop: "10px",
  },
};